<template>
    <div>
        <v-card>
            <v-card-actions class="mx-3">
                <v-spacer />
                <v-btn class="mr-3 mb-3 mt-2 white--text" small color="green" depressed @click="export2xls">Export to XLS</v-btn>
            </v-card-actions>
            <v-card-subtitle>
                <div style="text-align:center; font-weight:bold; font-size:16px; padding:10px">EXPIRED LOGISTIK</div>

                <v-row class="compact-form my-2">
                    <v-col cols="1">
                        Tanggal Produksi
                    </v-col>
                    <v-col cols="3">
                        <v-menu v-model="dateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined></v-text-field>
                            </template>
                            <v-date-picker v-model="date" @change="handleChangeDate"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="1">
                        Volume
                    </v-col>
                    <v-col cols="3">
                        <v-select :items="volumes" item-text="description" item-value="code" v-model="volume" outlined dense hide-details="auto" @change="handleChangeVolume" />
                    </v-col>
                    <v-col cols="1">
                        Kategori
                    </v-col>
                    <v-col cols="3">
                        <v-select :items="categories" item-text="description" item-value="code" v-model="category" outlined dense hide-details="auto" @change="handleChangeCategory" clearable />
                    </v-col>
                </v-row>
            </v-card-subtitle>
            <v-card-text class="">
                <div id="printresep" style="overflow: auto;">
                    <v-simple-table fixed-header height="500px" id="variantTbl" ref="tableBOM">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th colspan="3"></th>
                                    <th class="text-center" rowspan="2">Delivery</th>
                                    <th class="text-center" v-for="(day, idday) in days" :key="idday">
                                        {{ day.day_name }}
                                    </th>
                                </tr>
                                <tr>
                                    <th colspan="3"></th>
                                    <th class="text-center" v-for="(day, idday) in days" :key="idday">
                                        {{ day.date_format }}
                                    </th>
                                </tr>
                                <tr>
                                    <th colspan="3"></th>
                                    <th></th>
                                    <th class="text-center" v-for="(day, idday) in days" :key="idday">{{ day.coordinator_name }}</th>
                                </tr>
                                <tr>
                                    <th width="10" rowspan="2">No</th>
                                    <th width="10" rowspan="2">Kode</th>
                                    <th rowspan="2">Produk {{ volume }} ml</th>
                                    <th class="text-center" rowspan="2">PPIC Produksi</th>
                                    <th class="text-center" v-for="(day, idday) in days" :key="idday">
                                        Expired
                                    </th>
                                </tr>
                                <tr>
                                    <th class="text-center" v-for="(day, idday) in days" :key="idday">
                                        <span v-if="day.coordinator_code=='STKCKP'">
                                            {{ day.remarks }}
                                        </span>
                                        <span v-else>
                                            {{ day.expired_date | moment }}
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(product, pidx) in products" :key="product.product_code">
                                    <td>{{ pidx + 1 }}</td>
                                    <td>{{ product.product_code }}</td>
                                    <td>{{ product.product_name }}</td>
                                    <td class="text-center">{{ getQtyTotal(product.product_code) || '' }}</td>
                                    <td class="text-center" v-for="(day, idday) in days" :key="idday">
                                        {{ getQtyCoordinator(day, product.product_code) || '' }}
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colspan="3" class="text-right">Jumlah Total</th>
                                    <th class="text-center">{{ sumQty || '' }}</th>
                                    <th class="text-center" v-for="(day, idday) in days" :key="idday">
                                        {{ sumQtyCoordinator(day) || '' }}
                                    </th>
                                </tr>
                            </tfoot>
                        </template>
                    </v-simple-table>
                </div>
            </v-card-text>
        </v-card>

        <v-overlay :value="isLoading" z-index="999">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>  
    </div>
</template>

<script>
import moment from 'moment';
import { utils, writeFileXLSX } from 'xlsx';

export default {
    data: () => ({
        isLoading: false,
        dateMenu: false,
        date: null,
        category: '',
        volume: '250',
        categories: [],
        volumes: [],
        products: [],
        coordinators: [],
        items: [],
        days: [],
    }),

    filters: {
        moment: function (date) {
            return moment(date).format('D MMM YYYY');
        },
        numbers: function (number) {
            return Number(number).toLocaleString()
        }
    },

    async created() {
        this.date = moment().format('YYYY-MM-DD');
        this.getVolumes();
        this.getCategories();

        this.getData();
    },

    computed: {
        sumQty() {
            return this.products.reduce((total, item) => total + this.getQtyTotal(item.product_code), 0);
        },
    },

    methods: {
        handleChangeDate() {
            this.getData();
        },
        handleChangeVolume() {
            this.getData();
        },
        handleChangeCategory() {
            this.getData();
        },
        getVolumes() {
            let dataMiscCodes = this.$store.state.misccode.objs;
            this.volumes = dataMiscCodes.filter((i => i.type.includes('Botol') && i.code !== '500'))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                });
        },
        getQtyCoordinator(data, productCode) {
            let result = 0;

            const item = this.items.find((item) => item.variant_code == productCode 
                && item.delivery_date == data.date 
                && item.expired_date == data.expired_date 
                && item.coordinator_code == data.coordinator_code);
            if (item) {
                result = parseInt(item.total) || 0;
            }

            return result;
        },
        sumQtyCoordinator(data) {
            return this.products.reduce((total, item) => total + this.getQtyCoordinator(data, item.product_code), 0);
        },
        getQtyTotal(productCode) {
            let result = 0;

            this.days.forEach(item => {
                result += this.getQtyCoordinator(item, productCode);
            });

            return result;
        },
        async getCategories() {
            // let response = await this.$store.dispatch('ordercategory/getObjs');
            let listdata = [{code:'all', description:'All'}, {code:'ZIRCON', description:'ZIRCON'}];
            
            // response.data.data.forEach((item) => {
            //     listdata.push({
            //         code: item.code,
            //         description: item.description
            //     });
            // });
            this.categories = listdata;
        },
        async getData() {
            this.isLoading = true;
            
            try {
                const data = (await this.$store.dispatch('expiredlogistik/getData', {
                    date: this.date,
                    size: this.volume,
                    category: this.category,
                }));

                this.coordinators = data.coordinators;
                this.days = data.days;
                this.products = data.products;
                this.items = data.items;
            } catch (error) {
                console.log('Error fetching data:', error);
            } finally {
                this.isLoading = false;
            }
        },
        export2xls() {
            console.log(this.$refs.tableBOM.$el.firstChild.firstChild);
            const wb = utils.table_to_book(this.$refs.tableBOM.$el.firstChild.firstChild);
            writeFileXLSX(wb, "Expired-Logistik.xlsx");
        },
    }
}
</script>

<style scoped>
table, th, td {
  border: 1px solid grey;
  border-collapse: collapse;
}
#printresep th, td {
  padding: 10px;
  font-size: 12px;
}
.box {
    border:1px solid grey;
    height:30px;
    width:100px;    
}

.v-data-table table tfoot th
{
	position: sticky;
	bottom: 0;
	background: #FFF;
}
</style>